<template>
  <div class="head-grid-container">
    <div>
      <img class="head-grid-logo" src="../assets/logo-WMADCC_FNL.jpg">
    </div>

    <div class="slider-container">

      <div id="slider">
        <figure>
          <img src="../assets/HeadSlide1.jpg">
          <img src="../assets/HeadSlide2.jpg">
          <img src="../assets/HeadSlide3.jpg"> 
          <img src="../assets/HeadSlide4.jpg">
          <img src="../assets/HeadSlide1.jpg">
        </figure>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'HomeHeader'
  }

</script>
  
<style scoped>

/* for desktop */
@media (min-width:701px) {

  .head-grid-container {
    display: grid;
    grid-template-columns: 2fr 4.5fr;
    background-color: rgb(255, 243, 224);
    height: 20vw;
  }

  .head-grid-logo {
    max-width: 100%;
    max-height: 60%;
    min-height: 18vw;  
    display: flex;
    padding: 1vw;
    margin-left: 6vw; 
    margin-right: 6vw;   
  }

  .slider-container {
    display: flex;
    max-width: 70%;
    max-height: 60%;
    min-height: 17vw;
    margin-left: 14vw;
    margin-top: 1.2vw;
    border: 5px solid #fff;
    transform: translate (-50%, -50%);
  }  

  #slider {
    overflow: hidden;
  }

  #slider figure {
    position: relative;
    width: 500%;
    margin: 0;
    animation: 20s slider infinite;
  } 

  #slider figure img {
    float: left;
    width: 20%;
  }

 @keyframes slider {
    0% {left: 0;}
    20% {left: 0;}
    25% {left: -100%;}
    45% {left: -100%;}
    50% {left: -200%;}
    70% {left: -200%;}
    75% {left: -300%;}
    95% {left: -300%;}
    100% {left: -400%;}
 }
}

/* for Phone */
@media (max-width:700px) {

  .head-grid-logo {
    width: 15rem;
    height: auto;
  }

  img {
    width: 0rem;
    height: 0rem;
    margin-bottom: -2.5rem;
  }  

}
  
</style>